import { Link, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/not-found')({
  component: MembershipNotFound,
})

export function MembershipNotFound() {
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-slate-50 px-4 py-16 text-slate-900 dark:bg-slate-950 dark:text-slate-50">
      <div className="w-full max-w-4xl rounded-3xl border border-slate-200/70 bg-white/90 p-10 shadow-[0_20px_45px_rgba(15,23,42,0.15)] backdrop-blur dark:border-slate-800 dark:bg-slate-900/70">
        <div className="flex flex-col gap-8">
          <div className="flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.4em] text-slate-500 dark:text-slate-400">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-emerald-50 text-emerald-600 dark:bg-emerald-300/20 dark:text-emerald-200">
              404
            </span>
            Membership error
          </div>
          <div className="space-y-4">
            <h1 className="text-4xl font-semibold leading-tight text-slate-900 dark:text-slate-50">
              We can’t find the page you’re looking for.
            </h1>
            <p className="text-base text-slate-600 dark:text-slate-300">
              The link might be outdated or the page might have moved. You can refresh the browser or continue from one of the
              anchored actions below to stay on track.
            </p>
          </div>
          <div className="flex flex-wrap gap-3">
            <Link
              to="/"
              className="inline-flex items-center justify-center rounded-full border border-slate-900/10 px-6 py-2.5 text-sm font-semibold tracking-wide text-slate-900 transition hover:border-slate-900/40 dark:border-slate-100/20 dark:text-slate-50"
            >
              Return to dashboard
            </Link>
            <Link
              to="/login"
              className="inline-flex items-center justify-center rounded-full bg-slate-900 px-6 py-2.5 text-sm font-semibold tracking-wide text-white transition hover:bg-slate-800 dark:bg-slate-50 dark:text-slate-900 dark:hover:bg-slate-200"
            >
              Go to sign in
            </Link>
            <Link
              to="/membership/apply"
              className="inline-flex items-center justify-center rounded-full border border-slate-900/10 px-6 py-2.5 text-sm font-semibold tracking-wide text-slate-900 transition hover:border-slate-900/40 dark:border-slate-100/20 dark:text-slate-50"
            >
              Continue an application
            </Link>
          </div>
          <p className="text-sm text-slate-500 dark:text-slate-400">
            Still stuck? Share the URL with your membership admin so we can swiftly resolve the routing issue.
          </p>
        </div>
      </div>
    </div>
  )
}
